<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="550"
    [nzVisible]="isVisibleaccountTypeDrawer" [nzTitle]="accountTypeDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.accountTypeForm">
        <div nz-row [nzGutter]="{ xs: 24, sm: 24, md: 24, lg: 24 }">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="nameError">
                        <label class="label-text required">{{TypeCategory[SelectedTypeCategory]}} Type name</label>
                        <input type="text" pattern="^(?!\s+$).+" class="input-group" nz-input
                            formControlName="accountTypeName" maxlength="25" minlength="2">
                        <ng-template #nameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter
                                {{TypeCategory[SelectedTypeCategory].toLowerCase()}} type
                                name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">{{TypeCategory[SelectedTypeCategory]}}
                                type name must contain at least
                                2
                                characters</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter
                                {{TypeCategory[SelectedTypeCategory].toLowerCase()}} type
                                name</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item class="margin-none">
                    <nz-form-control class="switch-box">
                        <nz-switch formControlName="isActive"></nz-switch>
                        <label class="switch-label black mr-1">Active</label>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end ">
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">{{selectedTypeData != null ? 'Update' : 'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()" class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>